import React from 'react';
import { Sparkles, Menu, Eye, Shield } from 'lucide-react';
import { PageSection } from '../../../../types';
import { ActionLinkInput } from '../common/ActionLinkInput';

interface HeaderEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const HeaderEditor: React.FC<HeaderEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};

  return (
    <div className="space-y-6">
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Menu className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">Header & Menü Ayarları</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Logo Metni (Alternatif)</label>
          <input
            type="text"
            value={content.title ?? ''}
            onChange={(e) => onUpdateContent({ title: e.target.value })}
            placeholder="Logo görseli yoksa görünecek metin..."
            className="w-full bg-slate-900 border border-slate-700 text-xs font-bold text-slate-100 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="flex items-center justify-between p-3 rounded-xl bg-slate-900/60 border border-slate-700/60">
          <span className="text-xs font-bold text-slate-200">Yapışkan (Sticky) Üst Menü</span>
          <input
            type="checkbox"
            checked={content.sticky !== false}
            onChange={(e) => onUpdateContent({ sticky: e.target.checked })}
            className="w-4 h-4 accent-blue-600 rounded cursor-pointer"
          />
        </div>
      </div>

      {/* CTA Button */}
      <ActionLinkInput
        label="Üst Menü Sağ Eylem Butonu"
        buttonText={content.buttonText ?? 'Teklif Alın'}
        onButtonTextChange={(txt) => onUpdateContent({ buttonText: txt })}
        linkType={content.buttonLinkType || 'page'}
        onLinkTypeChange={(type) => onUpdateContent({ buttonLinkType: type })}
        linkValue={content.buttonLink || '/iletisim'}
        onLinkValueChange={(val) => onUpdateContent({ buttonLink: val })}
        whatsappPhone={content.whatsappPhone}
        onWhatsappPhoneChange={(phone) => onUpdateContent({ whatsappPhone: phone })}
      />
    </div>
  );
};
